import Vue from 'vue'
import {format, distanceInWordsToNow, parse} from 'date-fns'
import pt from 'date-fns/locale/pt'

Vue.filter('commas', function(value){
  let nStr = _.toNumber(value).toFixed(2) + '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? ',' + x[1] : ',00';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }
  return 'R$ ' + x1 + x2;
})
Vue.filter('percent', function(value){
  let nStr = _.toNumber(value).toFixed(2) + '';
  let x = nStr.split('.');
  let x1 = x[0];
  let x2 = x.length > 1 ? ',' + x[1] : ',00';
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, '$1' + '.' + '$2');
  }
  return x1 + x2 + '%';
})
Vue.filter('cpf', function(v){
  v = v.replace( /\D/g , "")
  v = v.replace( /(\d{3})(\d)/ , "$1.$2")
  v = v.replace( /(\d{3})(\d)/ , "$1.$2")
  v = v.replace( /(\d{3})(\d{1,2})$/ , "$1-$2")
  return v
})
Vue.filter('cep', function(v){
  v = v.replace( /\D/g , "")
  v = v.replace( /(\d{2})(\d)/ , "$1.$2")
  v = v.replace( /(\d{3})(\d{1,3})$/ , "$1-$2")
  return v
})
Vue.filter('date', function(value){
  if(!value){return null}
  let date = parse(value)
  return format(date, "DD/MM/YYYY")
})
Vue.filter('dateTime', function(value){
  if(!value){return null}
  let date = parse(value)
  return format(date, "DD/MM/YYYY, [às] HH:mm:ss")
})
Vue.filter('dateDistance', function(value){
  if(!value){return null}
  let date = parse(value)
  return distanceInWordsToNow(date, {
    includeSeconds: true,
    addSuffix: true,
    locale: pt
  })
})


// WEBPACK FOOTER //
// ./src/filters.js